import { render } from "./productBroadwise.vue?vue&type=template&id=0f548d92&scoped=true"
import script from "./productBroadwise.vue?vue&type=script&lang=js"
export * from "./productBroadwise.vue?vue&type=script&lang=js"

import "./productBroadwise.vue?vue&type=style&index=0&id=0f548d92&lang=scss&scoped=true"

import exportComponent from "G:\\ElectronicPointOfSales\\Mang.EposApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f548d92"]])

export default __exports__